import { useMemo } from 'react';

import { usePermissions } from '@work4all/data';

import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableLayoutV8Props } from '../../data-tables/table/EntityTableLayoutV8';

import { useOpenTimeTrackingMask } from './use-open-time-tracking-mask';

type Return = EntityTableLayoutV8Props['actions'];

export const useTimeTrackingMaskActions = (
  record: TimeTracking | undefined
): Return => {
  const { canAdd, canEdit } = usePermissions();
  const openTimeTrackingMask = useOpenTimeTrackingMask();

  return useMemo<Return>(() => {
    const isAddingDisabled = !canAdd({ entity: Entities.timeTracking });
    const isEditingDisabled =
      !record ||
      !canEdit({
        entity: Entities.timeTracking,
        record,
      });

    return {
      add: {
        handler: () => openTimeTrackingMask({ mode: 'create' }),
        disabled: isAddingDisabled,
      },
      edit: {
        handler: () => openTimeTrackingMask({ id: record.id, mode: 'edit' }),
        disabled: isEditingDisabled,
      },
    };
  }, [canAdd, record, canEdit, openTimeTrackingMask]);
};
